/**
 * Fabpad Promise — continuous horizontal marquee.
 * Supports multiple promise strips on one page.
 */
(function () {
  'use strict';

  var gap = 12;
  var speedPxPerSec = 36;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getVisibleCount() {
    return window.innerWidth >= 640 ? 3 : 1.2;
  }

  function initPromiseSection(section) {
    var viewport = section.querySelector('[data-promise-viewport]');
    var track = section.querySelector('[data-promise-track]');
    if (!viewport || !track) return;

    var originals = [];

    function clearClones() {
      track.querySelectorAll('[data-promise-clone]').forEach(function (node) {
        node.remove();
      });
    }

    function cacheOriginals() {
      originals = Array.prototype.filter.call(track.children, function (node) {
        return !node.hasAttribute('data-promise-clone');
      });
    }

    function cloneTiles() {
      clearClones();
      originals.forEach(function (tile) {
        var clone = tile.cloneNode(true);
        clone.setAttribute('data-promise-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    function getTileWidth() {
      var visible = getVisibleCount();
      var calculated = (viewport.clientWidth - gap * (Math.ceil(visible) - 1)) / visible;

      if (window.innerWidth < 640) {
        return Math.min(Math.max(calculated, 156), 180);
      }

      return Math.min(Math.max(calculated, 180), 220);
    }

    function applyTileWidths() {
      var tileWidth = getTileWidth();
      var tiles = track.querySelectorAll('.fabpad-promise__tile');

      tiles.forEach(function (tile) {
        tile.style.width = tileWidth + 'px';
        tile.style.flexBasis = tileWidth + 'px';
        tile.style.height = 'auto';
        tile.style.minHeight = '0';
      });

      var setWidth = originals.length * tileWidth + (originals.length - 1) * gap;
      var duration = Math.max(20, setWidth / speedPxPerSec);

      track.style.setProperty('--marquee-distance', setWidth + 'px');
      track.style.setProperty('--marquee-duration', duration + 's');
    }

    function restartAnimation() {
      track.classList.remove('fabpad-promise__track--marquee');
      void track.offsetWidth;
      if (!prefersReducedMotion) {
        track.classList.add('fabpad-promise__track--marquee');
      }
    }

    function refresh() {
      cacheOriginals();
      if (!originals.length) return;
      cloneTiles();
      applyTileWidths();
      restartAnimation();
    }

    section.addEventListener('mouseenter', function () {
      section.classList.add('is-paused');
    });

    section.addEventListener('mouseleave', function () {
      section.classList.remove('is-paused');
    });

    section.addEventListener('focusin', function () {
      section.classList.add('is-paused');
    });

    section.addEventListener('focusout', function (event) {
      if (!section.contains(event.relatedTarget)) {
        section.classList.remove('is-paused');
      }
    });

    window.addEventListener('resize', refresh, { passive: true });
    refresh();
  }

  function placeSharedPromise() {
    var slot = document.querySelector('[data-fabpad-promise-slot]');
    var root = document.getElementById('shopify-section-fabpad-promise');
    if (!slot || !root) return;
    var inner = root.querySelector('[data-fabpad-promise]');
    if (inner && !slot.contains(inner)) slot.appendChild(inner);
    if (!root.querySelector('[data-fabpad-promise]')) root.setAttribute('hidden', '');
  }

  placeSharedPromise();
  document.addEventListener('shopify:section:load', placeSharedPromise);

  document.querySelectorAll('[data-fabpad-promise]').forEach(initPromiseSection);
})();
